export const LANGUAGE = {
  KOR: 'KOR',
  ENG: 'ENG',
} as const;

export type Language = (typeof LANGUAGE)[keyof typeof LANGUAGE];
